export default "__VITE_ASSET__a5766fa5__"